import React from 'react';
import { X } from 'lucide-react';
import { Switch } from '../../../../components/ui/switch';
import { AiButton, StreamPreview } from '../shared';

const StepJsonLd = ({ wf, setData, runAi, ai }) => {
  const d = wf.data?.jsonld || {};
  const seo = wf.data?.seo || {};
  const faq = d.faq || [];
  const includeFaq = d.include_faq !== false;
  const running = ai.running && ai.action === 'faq';
  const origin = window.location.origin;

  const generate = async () => {
    const res = await runAi('faq');
    if (res) setData('jsonld', { ai: res, faq: res.faq || [] });
  };

  const blogPosting = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: wf.article?.title,
    description: seo.seo_description || wf.article?.excerpt,
    keywords: (seo.tags || []).join(', '),
    author: { '@type': 'Person', name: 'BriefingIQ Team' },
    publisher: { '@type': 'Organization', name: 'BriefingIQ' },
    mainEntityOfPage: `${origin}/blog/${seo.slug || ''}`,
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map((f) => ({ '@type': 'Question', name: f.question, acceptedAnswer: { '@type': 'Answer', text: f.answer } })),
  };

  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-[var(--line-2)] p-5">
        <div className="text-[11px] uppercase tracking-wider text-ink-3 mb-2">Article schema · added automatically on publish</div>
        <pre className="text-xs font-mono text-ink-2 whitespace-pre-wrap" data-testid="jsonld-article-preview">{JSON.stringify(blogPosting, null, 2)}</pre>
        <div className="text-[10px] text-ink-3 mt-2">Dates, cover image and breadcrumbs are filled from the live post.</div>
      </div>

      <div className="flex items-center justify-between">
        <AiButton onClick={generate} running={running} label={faq.length ? 'Regenerate FAQ with AI' : 'Generate FAQ schema with AI'} runningLabel="Writing FAQ…" testId="jsonld-faq-btn" />
        <label className="flex items-center gap-2 text-sm text-ink-2">
          Include FAQPage schema <Switch checked={includeFaq} onCheckedChange={(v) => setData('jsonld', { include_faq: v })} data-testid="jsonld-include-faq" />
        </label>
      </div>
      {running && <StreamPreview text={ai.text} label="Writing FAQ pairs…" />}
      {faq.length > 0 && !running && (
        <div className="space-y-2" data-testid="jsonld-faq-list">
          {faq.map((f, i) => (
            <div key={i} className="p-4 rounded-2xl border border-[var(--line-2)] flex gap-3">
              <div className="flex-1">
                <div className="text-sm font-medium text-ink">{f.question}</div>
                <div className="text-sm text-ink-2 mt-1">{f.answer}</div>
              </div>
              <button type="button" onClick={() => setData('jsonld', { faq: faq.filter((_, j) => j !== i) })} className="text-ink-3 hover:text-red-600" title="Remove"><X className="w-4 h-4" /></button>
            </div>
          ))}
          {includeFaq && (
            <details className="text-xs">
              <summary className="cursor-pointer text-ink-3">Preview FAQPage JSON-LD</summary>
              <pre className="mt-2 font-mono text-ink-2 whitespace-pre-wrap">{JSON.stringify(faqSchema, null, 2)}</pre>
            </details>
          )}
        </div>
      )}
    </div>
  );
};

export default StepJsonLd;
